import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  IoGridOutline,
  IoListOutline,
  IoLockOpenOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { BsArrowRight, BsHeadset } from "react-icons/bs";
import PageSkeleton from "../../../Components/Loader/PageSkeleton";
import { UserContext } from "../../../Context/UserContext";

const Dashboard = ({ children }) => {
  const { setIsLogin } = useContext(UserContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let Navigate = useNavigate();
  const location = useLocation();
  const isDashboardHome = location.pathname === "/dashboard";
  const customerName = localStorage.getItem("CN") || "there";

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    document.body.classList.toggle("overflow-hidden", loading);

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [loading]);

  const handleLogout = () => {
    setLoading(true);
    localStorage.removeItem("CID");
    localStorage.removeItem("CN");
    localStorage.removeItem("token");
    localStorage.removeItem("rzp_device_id");
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("rzp_checkout_user_id");
    setIsLogin(false);
    setTimeout(() => {
      Navigate("/");
    }, 1000);
  };

  return (
    <div>
      {loading ? <PageSkeleton type="dashboard" /> : (
        <div className="site-container">
          <div className="py-8 lg:py-10 flex flex-col lg:flex-row w-full">
            <div className="flex-shrink-0 w-full lg:w-80 mr-7 lg:mr-10  xl:mr-10 ">
              <div className="bg-white p-3 sm:p-4 lg:p-6 sticky top-32 border-r h-full border-gray-200">
                <Link
                  to="/dashboard"
                  className={`${
                    isDashboardHome
                      ? "bg-[#20211d] text-white"
                      : "text-gray-600 hover:bg-[#f5f3f1] hover:text-black"
                  } my-2 flex w-full items-center p-3`}
                >
                  <IoGridOutline
                    className="h-5 w-5 flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span className="ml-3 text-sm font-semibold md:text-base">Overview</span>
                </Link>
                <Link
                  to="/recent-orders"
                  className={`${
                    location.pathname.includes("orders")
                      ? "bg-[#20211d] text-white"
                      : "text-gray-600 hover:bg-[#f5f3f1] hover:text-black"
                  } my-2 flex w-full items-center p-3`}
                >
                  <IoListOutline
                    className="h-5 w-5 flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span className="ml-3 text-sm font-semibold md:text-base">My orders</span>
                </Link>
                <Link
                  to="/update-profile"
                  className={`${
                    location.pathname.includes("profile")
                      ? "bg-[#20211d] text-white"
                      : "text-gray-600 hover:bg-[#f5f3f1] hover:text-black"
                  } my-2 flex w-full items-center p-3`}
                >
                  <IoSettingsOutline
                    className="h-5 w-5 flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span className="ml-3 text-sm font-semibold md:text-base">Update profile</span>
                </Link>
                <div className="border-t border-gray-200 pt-2">
                  <button
                    className="my-2 flex w-full items-center p-3 text-gray-600 hover:bg-[#f5f3f1] hover:text-black"
                    onClick={handleLogout}
                  >
                    <IoLockOpenOutline className="h-5 w-5 flex-shrink-0" />
                    <span className="ml-3 text-sm font-semibold md:text-base">Logout</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="w-full bg-white mt-4 lg:mt-0 p-4 sm:p-5 lg:p-8 rounded-md overflow-hidden">
              {children || (
                <section>
                  <p className="text-xs font-bold uppercase text-[#858653]">My account</p>
                  <h1 className="mt-2 text-3xl font-semibold text-gray-900">
                    Welcome, {customerName}
                  </h1>
                  <p className="mt-3 max-w-2xl text-sm leading-6 text-gray-600">
                    Manage your orders and keep your account information up to date.
                  </p>

                  <div className="mt-8 grid grid-cols-1 gap-px border border-gray-200 bg-gray-200 md:grid-cols-2">
                    <Link to="/recent-orders" className="group bg-white p-6 md:p-8">
                      <IoListOutline className="text-[#858653]" size={26} aria-hidden="true" />
                      <h2 className="mt-5 text-xl font-semibold">Your orders</h2>
                      <p className="mt-2 text-sm leading-6 text-gray-600">
                        Review recent purchases, order details and delivery status.
                      </p>
                      <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold group-hover:text-[#858653]">
                        View orders <BsArrowRight aria-hidden="true" />
                      </span>
                    </Link>
                    <Link to="/update-profile" className="group bg-white p-6 md:p-8">
                      <IoSettingsOutline className="text-[#858653]" size={26} aria-hidden="true" />
                      <h2 className="mt-5 text-xl font-semibold">Profile details</h2>
                      <p className="mt-2 text-sm leading-6 text-gray-600">
                        Update your name, mobile number and email address.
                      </p>
                      <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold group-hover:text-[#858653]">
                        Manage profile <BsArrowRight aria-hidden="true" />
                      </span>
                    </Link>
                  </div>

                  <div className="mt-8 flex flex-col justify-between gap-5 bg-[#f5f3f1] p-6 sm:flex-row sm:items-center md:p-8">
                    <div>
                      <h2 className="text-lg font-semibold">Need help with an order?</h2>
                      <p className="mt-2 text-sm text-gray-600">Our Fina Interiors team is ready to assist.</p>
                    </div>
                    <Link to="/contact-us" className="inline-flex items-center gap-2 bg-[#20211d] px-5 py-3 text-sm font-semibold text-white hover:bg-black">
                      <BsHeadset aria-hidden="true" /> Contact support
                    </Link>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
